import {
    Box,
    HStack,
    IconButton,
    Menu,
    MenuButton,
    MenuDivider,
    MenuItem,
    MenuList,
    Text,
    useDisclosure,
} from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";

export type AppOptionBoxItem = {
    key: string;
    label: string;
    iconName?: string;
    divider?: boolean;
    isDisabled?: boolean;
    isHidden?: boolean;
};

export interface AppOptionsBoxProps<T> {
    options: AppOptionBoxItem[];
    onClick: (key: string, data?: T) => void;
    data?: T;
    iconName?: string;
    iconSize?: string;
    buttonSize?: string;
    isOpenOnHover?: boolean;
}

export const AppOptionsBox = <T,>({
    options,
    data,
    onClick,
    iconName = "icl-options",
    iconSize = "1.25rem",
    buttonSize = "xs",
    isOpenOnHover = false,
}: AppOptionsBoxProps<T>) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const menuHoverProps = {
        isOpen: isOpen,
    };

    const menuBttonHoverProps = {
        onMouseEnter: onOpen,
        onMouseLeave: onClose,
    };

    return (
        <>
            <Menu
                placement="bottom-end"
                offset={[0, -15]}
                {...(isOpenOnHover && { ...menuHoverProps })}
            >
                <MenuButton
                    as={IconButton}
                    size={buttonSize}
                    aria-label="Options"
                    icon={
                        <AppIcon
                            name={iconName}
                            w={iconSize}
                            color={"var(--chakra-colors-primary)"}
                        />
                    }
                    variant="unstyled"
                    {...(isOpenOnHover && { ...menuBttonHoverProps })}
                />
                <MenuList {...(isOpenOnHover && { ...menuBttonHoverProps })}>
                    {options?.map((option) => (
                        <Box key={option?.key}>
                            {!option.isHidden && (
                                <MenuItem
                                    onClick={() => onClick(option?.key, data)}
                                    isDisabled={option?.isDisabled}
                                >
                                    <HStack>
                                        {option?.iconName && (
                                            <AppIcon
                                                name={option.iconName}
                                                w={"1rem"}
                                            />
                                        )}
                                        <Text
                                            textStyle={"mediumSm"}
                                            lineHeight={"normal"}
                                            marginLeft={2}
                                        >
                                            {option.label}
                                        </Text>
                                    </HStack>
                                </MenuItem>
                            )}
                            {option?.divider && <MenuDivider />}
                        </Box>
                    ))}
                </MenuList>
            </Menu>
        </>
    );
};
